import React, { useEffect, useState } from 'react';

export const usePagination = () => {
  const [nextRows, setNextRows] = useState(5);
  const [totalRows, setTotalRows] = useState(0);
  const nextRowsOptions = [5, 10, 25, 50, 100];
  const [initialRow, setInitialRow] = useState(0);
  const [page, setPage] = useState(0);

  useEffect(() => {
    setInitialRow(0);
  }, [nextRows]);

  const onChangePage = (pageFrom: number) => {
    setInitialRow(pageFrom);
  };

  const clearPagination = () => {
    setInitialRow(0);
    setNextRows(5);
  };

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, newPage: number) => {
    const pageFrom = newPage * nextRows;
    onChangePage(pageFrom);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNextRows(parseInt(event.target.value, 10));
    setPage(0);
  };

  return {
    page,
    nextRows,
    totalRows,
    initialRow,
    nextRowsOptions,
    setTotalRows,
    clearPagination,
    handleChangePage,
    handleChangeRowsPerPage
  };
};
